import { useEffect, useRef, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import LatinicaWarningModal from "../LatinicaWarningModal";
import parseBullets from "../../../../utils/parseBullets";

const styles = {
  button: {
    padding: "10px 20px"
  }
};

const RiziciModal = ({ handleConfirm, handleCancel, rizici }) => {
  const [newRizici, setNewRizici] = useState(rizici);
  const [openLatinicaModal, setOpenLatinicaModal] = useState(false);

  const ref = useRef();

  useEffect(() => {
    setNewRizici(rizici);
  }, [rizici]);

  const handleChange = (e) => {
    setNewRizici(parseBullets(e.target.value));
  };

  const handleKeyDown = (e) => {
    const key = e.key;
    if (/^[A-Za-z]$/.test(key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }

    if (e.key === "Enter") {
      e.preventDefault();

      const textarea = ref.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      const before = newRizici.substring(0, start);
      const after = newRizici.substring(end);

      const newValue = before + "\n- " + after;
      setNewRizici(newValue);

      requestAnimationFrame(() => {
        const pos = start + 3;
        textarea.setSelectionRange(pos, pos);
      });
    }
  };

  const handleCancelLatinica = () => setOpenLatinicaModal(false);

  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "60%",
          borderRadius: "10px",
          padding: "20px"
        }}
      >
        <textarea
          ref={ref}
          value={newRizici}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          rows={30}
          style={{ width: "100%", padding: "10px", fontSize: "14px" }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px"
          }}
        >
          <div onClick={handleCancel} style={{ width: "10vw", height: "40px" }}>
            <Button activation={true} style={styles.button}>
              <span style={{ fontWeight: "bold" }}>ODUSTANI</span>
            </Button>
          </div>
          <div
            onClick={() => handleConfirm(newRizici)}
            style={{ width: "10vw", height: "40px" }}
          >
            <Button activation={true} style={styles.button}>
              <span style={{ fontWeight: "bold" }}>SACUVAJ</span>
            </Button>
          </div>
        </div>
      </div>
      {openLatinicaModal && (
        <LatinicaWarningModal handleCancel={handleCancelLatinica} />
      )}
    </div>
  );
};

export default RiziciModal;
